import Module from '../../utils/modules/Module';

export default class TabModule extends Module {
  constructor(options) {
    super(options)

    // Variables
    this.DOMEl = this.options.element;
    this.btns = this.DOMEl.querySelectorAll('[role="tab"]');
    this.btnsGroup = this.DOMEl.querySelector('[role="tablist"]');
    this.tabFocus = 0;

    // Event listeners
    this.onKeyDown_bind = this.onKeyDown.bind(this);
    this.changeTab_bind = this.changeTab.bind(this);

    this.init();
  }


  /**
   * Define the initial state
   */
  init() {
    this.btnsGroup.addEventListener("keydown", this.onKeyDown_bind);

    this.btns.forEach(btn => {
      btn.addEventListener('click', this.changeTab_bind);
    });

    // Place underline width
    let line = document.querySelector('.tab-list-line');
    if (line) {
      line.style.width = (document.querySelector('.tab-item:first-of-type').offsetWidth - 32) + 'px';
    }

    // Show first of type content
    let first = this.DOMEl.querySelector('[role="tabpanel"]');
    first.classList.remove('fade');
    first.removeAttribute('hidden');
  }


  /** ------------------------------
   * Events
   --------------------------------- */
  /**
   * Keyboard accessibility
   * @param e -> the group of tabs
   */
  onKeyDown(e) {
    // Move
    if (e.keyCode === 39 || e.keyCode === 37) {
      this.btns[this.tabFocus].setAttribute("tabindex", '-1');

      // Move right
      if (e.keyCode === 39) {
        this.tabFocus++;
        // If we're at the end, go to the start
        if (this.tabFocus >= this.btns.length) {
          this.tabFocus = 0;
        }

        // Move left
      } else if (e.keyCode === 37) {
        this.tabFocus--;
        // If we're at the start, move to the end
        if (this.tabFocus < 0) {
          this.tabFocus = this.btns.length - 1;
        }
      }

      this.btns[this.tabFocus].setAttribute("tabindex", '0');
      this.btns[this.tabFocus].focus();
    }
  }



  /**
   * Open a tab and close the others
   * @param e -> the tab clicked
   */
  changeTab(e) {
    const target = e.target;
    const parent = target.parentNode;
    const grandparent = parent.parentNode;
    let allTabs = parent.querySelectorAll('[aria-selected="true"]');
    let allPanels = grandparent.querySelectorAll('[role="tabpanel"]');
    let selectedPanel = grandparent.parentNode.querySelector(`#${target.getAttribute("aria-controls")}`);
    let line = parent.querySelector('.tab-list-line');
    let posX = 0;

    // TABS
    // ------------------------------------------
    // Remove all current selected tabs
    allTabs.forEach(t => t.setAttribute("aria-selected", 'false'));

    // Set this tab as selected
    target.setAttribute("aria-selected", 'true');

    // Move underline
    if (line) {
      let position = 0;
      this.btns.forEach( (btn, int) => {
        btn.classList.add('btn-'+(int+1));
        if (e.target.classList.contains('btn-'+(int+1))) {
          position = (int+1);
        }
      });

      for (let i = 1; position > i; i++) {
        let elX = parent.querySelector('.tab-item:nth-of-type('+i+')').offsetWidth;
        posX += elX;
      }

      line.style.width = (parent.querySelector('.tab-item:nth-of-type('+position+')').offsetWidth - 32) + 'px';
      line.style.left = posX + 'px';
    }

    // PANELS
    // ------------------------------------------
    // Hide all tab panels - opacity
    allPanels.forEach(p => p.classList.add('fade'));

    setTimeout(function () {
      // Hide all tab panels - add hidden
      allPanels.forEach(p => p.setAttribute("hidden", 'true'));
      // Place the selected panel - remove hidden
      selectedPanel.removeAttribute("hidden");
    }, 400);

    // Show the selected panel - opacity
    setTimeout(function () {
      selectedPanel.classList.remove('fade');
    }, 500);
  }





}
